import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClick", "disabled", "children"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { useAssetActions } from 'asset-actions-lib/context/AssetActionsContext';
import { useCreateCustomAgentActionWizard } from 'forms-ai-lib/hooks/experimental/useCreateCustomAgentActionWizard';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import { FORM_ACTION_IDS } from 'asset-actions-lib-forms/constants/actionIds';
import { BreezeSingleStarIcon } from 'foundations-assets/icons/components/BreezeSingleStarIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CreateCustomerAgentActionButton = _ref => {
  let {
      onClick,
      disabled,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    openCreateCustomerAgentActionWizard
  } = useCreateCustomAgentActionWizard();
  const {
    crmObject,
    onActionError,
    onActionSuccess
  } = useAssetActions();
  const formId = getPropertyValue(crmObject, 'hs_form_id');
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    if (formId) {
      openCreateCustomerAgentActionWizard({
        formId
      }).then(result => {
        if (!result.cancelled && onActionSuccess) {
          onActionSuccess({
            actionId: FORM_ACTION_IDS.CREATE_CUSTOMER_AGENT_ACTION,
            data: {
              formId
            }
          });
        }
      }).catch(error => {
        if (onActionError) {
          onActionError({
            actionId: FORM_ACTION_IDS.CREATE_CUSTOMER_AGENT_ACTION,
            data: {
              formId
            },
            error
          });
        }
      });
    } else {
      if (onActionError) {
        onActionError({
          actionId: FORM_ACTION_IDS.CREATE_CUSTOMER_AGENT_ACTION,
          data: {
            formId
          }
        });
      }
      FloatingAlertStore.addAlert({
        id: 'create-customer-agent-action-failed',
        type: 'warning',
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.alerts.createCustomerAgentAction.failed.title"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.alerts.createCustomerAgentAction.failed.body"
        })
      });
    }
  };
  return /*#__PURE__*/_jsxs(Button, Object.assign({
    use: "tertiary-light",
    "data-test-id": "create-customer-agent-action-button",
    onClick: handleClick,
    disabled: disabled
  }, rest, {
    children: [/*#__PURE__*/_jsx(BreezeSingleStarIcon, {
      size: "300"
    }), children]
  }));
};
export default CreateCustomerAgentActionButton;